import { CircularProgress, Dialog } from '@mui/material';
import { Component } from "react";

interface PropsInterface {
    isOpen: boolean
}

class LoadingComponent extends Component {

    public props: PropsInterface

    constructor(props: any) {
        super(props);
        this.props = props;
    }

    render() {
        return(
            <Dialog
                open={this.props.isOpen}
                color="transparent"
                fullScreen={true}
                PaperProps={{
                    style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    },
                }}
            >
                <div style={{ 'backgroundColor': 'transparent', 'width': '100%', 'height': 'auto', 'textAlign': 'center', 'margin': 'auto' }}>
                    <CircularProgress size={100}/>
                </div>
            </Dialog>
        )
    }
}

export default LoadingComponent;